import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BRAND } from '../../../../data/brand/brand.data';
import { INFORMATION_TYPES } from '../../../../data/information/information.data';
import { URLS } from '../../../../data/navigation/navigation.data';

@Component( {
  selector: 'app-not-found-page',
  templateUrl: './not-found-page.component.html',
  styleUrls: [ './not-found-page.component.scss' ]
} )
export class NotFoundPageComponent {

  URLS = URLS;
  BRAND = BRAND;
  INFORMATION_TYPES = INFORMATION_TYPES;

  appHeroContents = [
    { text: '404 Page not found', level: 1 },
    { text: 'Looks like you are lost, let\'s get you back home.' }
  ];

  // Useful places for a lost visitor to land.
  quickLinks = [
    { label: 'Browse Themes', url: URLS.themes },
    { label: 'Browse Tools', url: URLS.tools.tools },
    { label: 'Read the Blog', url: URLS.blog },
  ];

  // Self-contained on purpose. The previous version reached into the shared
  // <app-top-svg> gradients via document.getElementById(...).setAttribute(),
  // which threw a runtime error whenever those elements weren't in the DOM.
  // Dropping that decorative side effect makes the 404 page crash-proof and
  // independent of any surrounding layout.
  constructor( public router: Router ) {
  }
}
